import React from 'react';
import { Button } from '@ui';
import { Popup } from '@progress/kendo-react-popup';
import ClickAwayListener from 'react-click-away-listener';
import { translate } from '@utils/i18n';
import { IndexNamespace } from '../constants';
function NoteActions({ canEdit, canDelete, onEdit, onDelete }) {
    const anchor = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const handleToggleOpen = React.useCallback(() => {
        setOpen(true);
    }, []);
    const handleClose = React.useCallback(() => {
        setOpen(false);
    }, []);
    if (!canEdit && !canDelete) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: "noteEllipsisButton", onClick: handleToggleOpen, ref: anchor },
            React.createElement("i", { className: "fa-light fa-ellipsis" })),
        React.createElement(Popup, { anchor: anchor.current, show: open, onClose: handleClose },
            React.createElement(ClickAwayListener, { onClickAway: handleClose },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation" },
                        canEdit && (React.createElement("li", { role: "presentation" },
                            React.createElement(Button, { onClick: () => {
                                    onEdit();
                                    handleClose();
                                } },
                                React.createElement("i", { className: "fa-light fa-pencil" }),
                                translate('edit_note', { namespace: IndexNamespace })))),
                        canDelete && (React.createElement("li", { role: "presentation" },
                            React.createElement(Button, { onClick: () => {
                                    onDelete();
                                    handleClose();
                                } },
                                React.createElement("i", { className: "fa-light fa-trash-can" }),
                                translate('delete', { namespace: 'features.commons' }))))))))));
}
export default React.memo(NoteActions);
